module.exports = __webpack_public_path__ + "img/Store.797ed212.png";